import { render, staticRenderFns } from "./CrudSimpleView.vue?vue&type=template&id=97f63bc8&"
import script from "./CrudSimpleView.vue?vue&type=script&lang=js&"
export * from "./CrudSimpleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports